import { useEffect, useMemo, useState } from "react";
import NewSession from "./NewSession";
import Scorer from "./Scorer";
import Leaderboards from "./Leaderboards";
import Groups from "./Groups";
import ScoreSettings from "./ScoreSettings";
import SessionList from "./SessionList";
import PlayerAnalytics from "./PlayerAnalytics";
import { scoringApi } from "@/lib/scoring";
import { opsApi } from "@/lib/ops";

const tab = (on) => `px-4 py-2.5 text-sm font-bold border-b-2 transition-colors whitespace-nowrap ${on ? "border-[#2563EB] text-[#0B0F19]" : "border-transparent text-slate-500 hover:text-[#0B0F19]"}`;

export default function ScoringTab({ ctx }) {
  const api = useMemo(() => scoringApi(ctx.token), [ctx.token]);
  const ops = useMemo(() => opsApi(ctx.token), [ctx.token]);
  const [cfg, setCfg] = useState(null);
  const [view, setView] = useState("scoring");
  const [open, setOpen] = useState("");
  const [creating, setCreating] = useState(false);
  const [target, setTarget] = useState({ pid: "", discipline: "hitting" });
  useEffect(() => { api.get("/scoring/config").then(setCfg); }, [api]);
  const admin = cfg?.role === "admin";
  const views = [["groups", "Groups"], ["scoring", "Scoring"], ["leaderboards", "Leaderboards"], ["analytics", "Player Analytics"], ["history", "Session History"], ...(admin ? [["settings", "Setup"]] : [])];
  const openSession = (i) => { setCreating(false); setOpen(i); };
  const body = open ? <Scorer api={api} ops={ops} id={open} cfg={cfg} onBack={() => setOpen("")} onNew={() => { setOpen(""); setView("scoring"); setCreating(true); }} />
    : view === "scoring" ? (creating ? <NewSession api={api} onCreated={openSession} onCancel={() => setCreating(false)} /> : <SessionList api={api} mode="active" admin={admin} onOpen={openSession} onStart={() => setCreating(true)} />)
    : view === "history" ? <SessionList api={api} mode="manage" admin={admin} onOpen={openSession} />
    : view === "leaderboards" ? <Leaderboards api={api} admin={admin} onPlayer={(pid, discipline) => { setTarget({ pid, discipline }); setView("analytics"); }} />
    : view === "analytics" ? <PlayerAnalytics api={api} ops={ops} admin={admin} target={target} setTarget={setTarget} onOpenSession={openSession} />
    : view === "groups" ? <Groups api={api} />
    : cfg && <ScoreSettings api={api} cfg={cfg} onSaved={(c) => setCfg({ ...c, role: cfg.role })} />;
  return (
    <div data-testid="scoring-tab" className="rounded-3xl bg-white text-[#0B0F19] p-5 md:p-8 -mx-2 md:mx-0">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">Scoring</h1>
      <p className="mt-2 text-sm font-medium text-slate-500">Score hitting and pitching reps live, compare players and track progress.</p>
      <nav className="mt-6 mb-6 flex gap-1 overflow-x-auto border-b border-slate-200">
        {views.map(([k, l]) => <button key={k} data-testid={`scoring-view-${k}`} onClick={() => { setOpen(""); setCreating(false); setView(k); }} className={tab(view === k && !open)}>{l}</button>)}
      </nav>
      {body}
    </div>
  );
}
